import { useQuery, UseQueryResult, useInfiniteQuery, InfiniteData, QueryKey } from '@tanstack/react-query';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AccountId, BookedTransactions, Loan, LoanAccount, PendingTransaction } from '../generated-types';
import { getBookedTransactions, getLoanDetails, getLoans, getPendingTransactions } from '../services/accountService';

export const useLoans = (enabled = true): UseQueryResult<Loan[], RequestExceptionWithResponse> =>
    useQuery({
        queryKey: ['loans'],
        queryFn: getLoans,
        enabled,
    });

export const useLoanDetails = (accountId?: AccountId): UseQueryResult<LoanAccount, RequestExceptionWithResponse> =>
    useQuery({
        queryKey: ['loans', accountId],
        queryFn: () => getLoanDetails(accountId!),
        enabled: !!accountId,
    });

export const useReservedTransactions = (
    accountId?: AccountId,
): UseQueryResult<PendingTransaction[], RequestExceptionWithResponse> =>
    useQuery({
        queryKey: ['pending-transactions', accountId],
        queryFn: () => getPendingTransactions(accountId!),
        enabled: !!accountId,
    });

export const useTransactions = (accountId?: AccountId) => {
    return useInfiniteQuery<
        BookedTransactions,
        RequestExceptionWithResponse,
        InfiniteData<BookedTransactions>,
        QueryKey,
        number
    >({
        queryKey: ['booked-transactions', accountId],
        queryFn: (arg) => getBookedTransactions(accountId!, arg.pageParam),
        getNextPageParam: (lastPage, allPages) => (lastPage.lastPage ? undefined : allPages.length + 1),
        enabled: !!accountId,
        initialPageParam: 1,
    });
};
